import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../commonComponents/translate';

function ChallengePlaceholder({ t }) {
  const styles = {
    container: {
      height: '18rem',
      justifyContent: 'center',
    },
    description: {
      textAlign: 'center',
      marginTop: '2rem',
    },
  };

  return (
    <div className="dashboard-challenge-item" style={styles.container}>
      <h6 className="challenge-name">{t('challengeList_noChallenges')}</h6>
      <div style={styles.description}>
        {t('challengeList_noChallenges_description')}
      </div>
    </div>
  );
}

ChallengePlaceholder.propTypes = {
  t: PropTypes.func.isRequired,
};

export default translate(ChallengePlaceholder);
